import { useRef, useState, useContext, useEffect } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { Typography, Breadcrumb } from "antd";
import logo from "../assests/baashyaam_logo.png";
import { AuthContext } from "../context/AuthContext";
import axios from "axios";

const { Text } = Typography;

export default function EmpIdCard({ employee }) {
    const cardRef = useRef();
    const { backUrl } = useContext(AuthContext);

    const [departments, setDepartments] = useState([]);
    const [designations, setDesignations] = useState([]);

    const fetchDepartments = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/departments/`);
            setDepartments(res.data.results);
        } catch (err) {
            console.error("Failed to fetch departments:", err);
        }
    };

    const fetchDesignations = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/designations/`);
            setDesignations(res.data.results);
        } catch (err) {
            console.error("Error fetching designations", err);
        }
    };

    useEffect(() => {
        fetchDepartments();
        fetchDesignations();
    }, []);

    const handleDownload = async () => {
        const element = cardRef.current;
        const canvas = await html2canvas(element, { scale: 2 });
        const imgData = canvas.toDataURL("image/png");

        const pdf = new jsPDF("p", "mm", "a4");
        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

        pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
        pdf.save(`ID_Card_${employee?.user?.username}.pdf`);
    };

    return (
        <>
            <Breadcrumb style={{ margin: "", fontSize: 14 }}></Breadcrumb>

            <div className="mt-2">
                <center>
                    {/* MAIN WRAPPER — PARALLEL FRONT/BACK */}
                    <div
                        ref={cardRef}
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "flex-start",
                            gap: "20px",
                            marginTop: "20px",
                        }}
                    >
                        {/* -------------------------------------- */}
                        {/* FRONT SIDE */}
                        {/* -------------------------------------- */}
                        <section
                            className="d-flex flex-column justify-content-between"
                            style={{
                                width: "250px",
                                height: "380px",
                                backgroundColor: "white",
                                borderRadius: "10px",
                                border: "1px solid gray",
                            }}
                        >
                            <div
                                style={{
                                    backgroundColor: "#29469dff",
                                    borderTopLeftRadius: "10px",
                                    borderTopRightRadius: "10px",
                                    padding: "10px",
                                    textAlign: "center",
                                }}
                            >
                                <img
                                    style={{ width: "210px", height: "80px" }}
                                    src={logo}
                                    alt="Logo"
                                />
                            </div>

                            <Text level={4} style={{ fontWeight: "bold" }}>
                                {employee?.user?.first_name} {employee?.user?.last_name}
                            </Text>

                            <div className="mt-2">
                                <img
                                    style={{
                                        width: "110px",
                                        height: "130px",
                                        borderRadius: "10px",
                                        border: "1px solid black",
                                    }}
                                    src={`${employee?.photo}`}
                                    alt="Employee"
                                    crossOrigin="anonymous"
                                />
                            </div>

                            <div className="mt-2">
                                <Text style={{ fontWeight: "bold", fontSize: "12px" }}>
                                    {employee?.designation_name}
                                </Text>
                                <br />
                                <Text style={{ fontWeight: "bold", fontSize: "12px" }}>
                                    Employee Code : {employee?.user?.username}
                                </Text>
                            </div>

                            <div
                                style={{
                                    backgroundColor: "#29469dff",
                                    width: "100%",
                                    height: "20px",
                                    borderBottomLeftRadius: "10px",
                                    borderBottomRightRadius: "10px",
                                }}
                            ></div>
                        </section>

                        {/* -------------------------------------- */}
                        {/* BACK SIDE */}
                        {/* -------------------------------------- */}
                        <section
                            className="d-flex flex-column justify-content-between align-items-center"
                            style={{
                                width: "250px",
                                height: "380px",
                                backgroundColor: "white",
                                borderRadius: "10px",
                                border: "1px solid gray",
                            }}
                        >
                            <div
                                style={{
                                    backgroundColor: "#29469dff",
                                    borderTopLeftRadius: "10px",
                                    borderTopRightRadius: "10px",
                                    padding: "10px",
                                    width: "100%",
                                    textAlign: "center",
                                }}
                            ></div>

                            <div style={{ padding: "10px", textAlign: "left", width: "100%" }}>
                                <Text style={{ display: "block", fontWeight: "bold", fontSize: "10px", marginBottom: "10px" }}>
                                    D.O.J : {employee?.date_of_joining || "N/A"}
                                </Text>
                                <Text style={{ display: "block", fontWeight: "bold", fontSize: "10px", marginBottom: "10px" }}>
                                    Blood Group : {employee?.blood_group}
                                </Text>
                                <Text style={{ display: "block", fontWeight: "bold", fontSize: "10px", marginBottom: "10px" }}>
                                    Emergency : {employee?.emergency_contact_number}
                                </Text>
                                <Text style={{ display: "block", fontWeight: "bold", fontSize: "10px" }}>
                                    Address : {employee?.address_for_communication}
                                </Text>
                            </div>

                            <div>
                                <img style={{ width: '200px', height: '60px' }} src={logo} alt="Logo" />
                            </div>

                            <div className="mb-2 px-1">
                                <Text style={{ display: "block", fontWeight: "bold", fontSize: "10px" }}>
                                    BAASHYAAM CONSTRUCTIONS PVT. LTD
                                </Text>
                                <Text style={{ display: "block", fontWeight: "bold", fontSize: "8px" }}>
                                    No. 87 GN Chetty Road, T.Nagar, Chennai - 600 017.
                                </Text>

                                <center><Text style={{ fontWeight: "bold", fontSize: "8px" }}>Ph: 044 4290 2345</Text></center>
                                <center><Text style={{ fontWeight: "bold", fontSize: "8px" }}>Email: info@bashyamgroup.com</Text></center>
                                <center><Text style={{ fontWeight: "bold", fontSize: "8px" }}>www.bashyamgroup.com</Text></center>

                                <hr />

                                <center>
                                    <Text style={{ fontWeight: "bold", fontSize: "8px", color: "#29469dff" }}>
                                        Finders of this card may kindly return it to the issuing authority.
                                    </Text>
                                </center>
                            </div>
                        </section>
                    </div>
                </center>
            </div>
        </>
    );
}
